module.exports = __webpack_public_path__ + "static/media/logo_symbole.077ce471.svg";